/* Presentation only: no cart handlers, no autoplay, no dependency on motion. */
(() => {
  if (window.bazV4HomeReady) return;
  window.bazV4HomeReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.b4h-heading, .b4h-product, .b4-native-card, .b4h-duo-card, .b4h-guide-card';
  const reveal = element => element.classList.remove('b4h-enter-pending');
  const init = (root = document) => {
    if (document.body.dataset.b4Motion === 'false' || reduce.matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }), { threshold: 0.02, rootMargin: '0px 0px -16px 0px' });
    root.querySelectorAll(selector).forEach(element => {
      const section = element.closest('.b4-home');
      if (!section || section.dataset.b4hMotion !== 'true' || element.dataset.b4hReady) return;
      element.dataset.b4hReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('b4h-enter', 'b4h-enter-pending');
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const element = event.target.closest('.b4h-enter-pending');
    if (element) reveal(element);
  });
  document.addEventListener('focusin', event => {
    const element = event.target.closest?.('.b4h-enter-pending');
    if (element) reveal(element);
  });
  reduce.addEventListener?.('change', event => {
    if (event.matches) document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
  });
})();

(() => {
  if (window.bazV4CardVariantsReady) return;
  window.bazV4CardVariantsReady = true;

  const cardSelector = 'product-card, .b4h-product';
  const linkSelector = [
    '[ref="productCardLink"]',
    '[ref="productTitleLink"]',
    '[ref="cardGalleryLink"]',
    '.b4h-product-image',
    '.b4h-product-details h3 a',
    '.b4h-product-action',
  ].join(',');

  const updateLinks = (card, variantId) => {
    if (!variantId) return;
    card.querySelectorAll(linkSelector).forEach(link => {
      if (!(link instanceof HTMLAnchorElement) || !link.href) return;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.href;
    });
  };

  const updateNativePrice = (card, button) => {
    const container = card.querySelector('product-price [ref="priceContainer"]');
    const html = button.dataset.priceHtml;
    if (!container || !html) return;
    container.innerHTML = html;
  };

  const updateHomePrice = (card, button) => {
    const price = card.querySelector('.b4h-product-price');
    if (!price) return;
    price.textContent = '';

    const current = document.createElement('span');
    current.textContent = button.dataset.priceText || '';
    current.dataset.bazMoney = button.dataset.priceAmount || '';
    current.dataset.bazBaseCurrency = button.dataset.nativeCurrency || 'KWD';
    price.append(current);

    if (button.dataset.saleActive === 'true' && button.dataset.compareText) {
      const compare = document.createElement('s');
      compare.textContent = button.dataset.compareText;
      compare.dataset.bazMoney = button.dataset.compareAmount || '';
      compare.dataset.bazBaseCurrency = button.dataset.nativeCurrency || 'KWD';
      price.append(compare);
    }
  };

  const updateBadges = (card, button) => {
    const hasSale = button.dataset.saleActive === 'true';
    card.querySelectorAll('[data-b4-sale-badge]').forEach(badge => {
      if (!(badge instanceof HTMLElement)) return;
      const nativeBadgeWrapper = badge.closest('.product-badges');
      if (hasSale && button.dataset.badgeText) {
        if (button.dataset.badgeHtml) badge.innerHTML = button.dataset.badgeHtml;
        else badge.textContent = button.dataset.badgeText;
        badge.hidden = false;
        badge.style.removeProperty('display');
        badge.removeAttribute('aria-hidden');
        if (nativeBadgeWrapper instanceof HTMLElement) {
          nativeBadgeWrapper.hidden = false;
          nativeBadgeWrapper.style.removeProperty('display');
          nativeBadgeWrapper.removeAttribute('aria-hidden');
        }
      } else {
        badge.textContent = '';
        badge.hidden = true;
        badge.style.display = 'none';
        badge.setAttribute('aria-hidden', 'true');
        if (nativeBadgeWrapper instanceof HTMLElement) {
          nativeBadgeWrapper.hidden = true;
          nativeBadgeWrapper.style.display = 'none';
          nativeBadgeWrapper.setAttribute('aria-hidden', 'true');
        }
      }
    });
  };

  const updateImage = (card, button) => {
    const imageUrl = button.dataset.variantImage;
    if (!imageUrl) return;

    const image = card.querySelector('.b4h-product-primary, .card-gallery img.product-media__image, .card-gallery img');
    if (!(image instanceof HTMLImageElement)) return;

    image.src = imageUrl;
    if (button.dataset.variantSrcset) image.srcset = button.dataset.variantSrcset;
    if (button.dataset.variantAlt) image.alt = button.dataset.variantAlt;

    const media = image.closest('[data-media-id]');
    if (media instanceof HTMLElement && button.dataset.variantMediaId) {
      media.dataset.mediaId = button.dataset.variantMediaId;
    }
    const slideshow = card.querySelector('slideshow-component');
    slideshow?.select?.(0, undefined, { animate: false });
    card.querySelectorAll('add-to-cart-component').forEach(component => {
      component.dataset.productVariantMedia = imageUrl;
    });
  };

  const selectButton = button => {
    const card = button.closest(cardSelector);
    if (!card) return;

    const group = button.closest('.b4-product-card-sizes');
    group?.querySelectorAll('[data-b4-card-variant]').forEach(option => {
      const active = option === button;
      option.classList.toggle('is-selected', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateLinks(card, button.dataset.variantId);
    updateNativePrice(card, button);
    updateHomePrice(card, button);
    updateBadges(card, button);
    updateImage(card, button);
    card.dispatchEvent(new CustomEvent('baz:money-update', { bubbles: true }));
    card.dataset.selectedVariant = button.dataset.variantId;
    card.querySelectorAll('product-form-component').forEach(component => {
      const variantInput = component.querySelector('input[name="id"]');
      const quantityInput = component.querySelector('input[name="quantity"]');
      const available = button.dataset.variantAvailable !== 'false';
      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = button.dataset.variantId;
        variantInput.disabled = !available;
      }
      if (quantityInput instanceof HTMLInputElement) quantityInput.value = button.dataset.variantQuantityMin || '1';
      component.dataset.quantityDefault = button.dataset.variantQuantityMin || '1';
      component.querySelectorAll('[ref="addToCartButton"]').forEach(add => {
        if (add instanceof HTMLButtonElement) add.disabled = !available;
      });
    });
    button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-b4-card-variant]');
    if (!(button instanceof HTMLElement)) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.getAttribute('aria-disabled') === 'true') return;
    selectButton(button);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const button = event.target.closest?.('[data-b4-card-variant]');
    if (!(button instanceof HTMLElement)) return;
    const group = button.closest('.b4-product-card-sizes');
    if (!group) return;
    const options = [...group.querySelectorAll('[data-b4-card-variant]')];
    const rtl = getComputedStyle(group).direction === 'rtl';
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const index = options.indexOf(button) + (rtl ? -direction : direction);
    const next = options[index];
    if (!(next instanceof HTMLElement)) return;
    event.preventDefault();
    next.focus();
    next.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
  });
})();

(() => {
  if (window.bazV4CardCarouselsReady) return;
  window.bazV4CardCarouselsReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const states = new WeakMap();
  const observed = new Set();
  const queued = new Set();
  let frame = 0;

  const pageTargets = track => {
    const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    const firstCard = track.querySelector(':scope > product-card');
    if (maximum < 2 || !(firstCard instanceof HTMLElement)) return [0];
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const stride = firstCard.getBoundingClientRect().width + gap;
    if (stride <= 0) return [0];
    const visible = Math.max(1, Math.floor((track.clientWidth + gap + 2) / stride));
    const step = visible * stride;
    const targets = [0];
    for (let offset = step; offset < maximum - 2; offset += step) targets.push(offset);
    targets.push(maximum);
    return targets;
  };

  const updateShelf = (track, controls, offset) => {
    const targets = pageTargets(track);
    controls.hidden = targets.length < 2;
    if (controls.hidden) return;
    let buttons = [...controls.querySelectorAll('[data-b4-carousel-page]')];
    if (buttons.length !== targets.length) {
      const dots = document.createDocumentFragment();
      const label = controls.dataset.b4CarouselPageLabel || '';
      targets.forEach((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'b4-card-carousel-dot';
        button.dataset.b4CarouselPage = String(index);
        button.setAttribute('aria-label', label.replace('__INDEX__', String(index + 1)).replace('__LENGTH__', String(targets.length)));
        const dot = document.createElement('span');
        dot.setAttribute('aria-hidden', 'true');
        button.append(dot);
        dots.append(button);
      });
      controls.replaceChildren(dots);
      buttons = [...controls.querySelectorAll('[data-b4-carousel-page]')];
    }
    const active = targets.reduce((closest, target, index) => Math.abs(target - offset) < Math.abs(targets[closest] - offset) ? index : closest, 0);
    buttons.forEach((button, index) => {
      button.dataset.b4CarouselOffset = String(targets[index]);
      button.setAttribute('aria-current', index === active ? 'true' : 'false');
    });
  };

  const update = carousel => {
    const track = carousel.querySelector(':scope > [data-b4-carousel-track]');
    const controls = carousel.querySelector(':scope > [data-b4-carousel-controls]');
    if (!(track instanceof HTMLElement) || !(controls instanceof HTMLElement)) return;
    const rtl = getComputedStyle(track).direction === 'rtl';
    const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    const offset = Math.max(0, Math.min(maximum, rtl ? -track.scrollLeft : track.scrollLeft));
    if (carousel.dataset.b4CarouselKind !== 'sizes') {
      updateShelf(track, controls, offset);
      return;
    }
    const overflowing = track.scrollWidth > carousel.clientWidth + 2;
    controls.hidden = mobile.matches || !overflowing;
    const previous = controls.querySelector('[data-b4-carousel-direction="previous"]');
    const next = controls.querySelector('[data-b4-carousel-direction="next"]');
    if (previous instanceof HTMLButtonElement) previous.disabled = offset < 2;
    if (next instanceof HTMLButtonElement) next.disabled = offset >= maximum - 2;
    if (previous?.disabled && next?.disabled) controls.hidden = true;
  };

  const schedule = carousel => {
    if (!(carousel instanceof HTMLElement)) return;
    queued.add(carousel);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      queued.forEach(current => {
        if (current.isConnected) update(current);
      });
      queued.clear();
    });
  };
  const observer = 'ResizeObserver' in window ? new ResizeObserver(entries => entries.forEach(entry => schedule(entry.target.closest('[data-b4-card-carousel]')))) : null;

  const release = carousel => {
    const state = states.get(carousel);
    state?.track.removeEventListener('scroll', state.onScroll);
    observer?.unobserve(carousel);
    if (state?.track) observer?.unobserve(state.track);
    states.delete(carousel);
    observed.delete(carousel);
    queued.delete(carousel);
  };

  const init = (root = document) => {
    observed.forEach(carousel => {
      if (!carousel.isConnected) release(carousel);
    });
    root.querySelectorAll('[data-b4-card-carousel]').forEach(carousel => {
      const track = carousel.querySelector(':scope > [data-b4-carousel-track]');
      if (!(track instanceof HTMLElement)) return;
      if (states.get(carousel)?.track === track) {
        schedule(carousel);
        return;
      }
      release(carousel);
      carousel.dataset.b4CarouselReady = 'true';
      const onScroll = () => schedule(carousel);
      track.addEventListener('scroll', onScroll, { passive: true });
      states.set(carousel, { track, onScroll });
      observer?.observe(carousel);
      observer?.observe(track);
      observed.add(carousel);
      update(carousel);
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-b4-carousel-page], [data-b4-carousel-direction]');
    if (!(button instanceof HTMLButtonElement)) return;
    const carousel = button.closest('[data-b4-card-carousel]');
    const track = carousel?.querySelector(':scope > [data-b4-carousel-track]');
    if (!(track instanceof HTMLElement)) return;
    event.preventDefault();
    const rtl = getComputedStyle(track).direction === 'rtl';
    if (button.hasAttribute('data-b4-carousel-page')) {
      const offset = Number(button.dataset.b4CarouselOffset);
      if (Number.isFinite(offset)) track.scrollTo({ left: (rtl ? -1 : 1) * offset, behavior: reduce.matches ? 'auto' : 'smooth' });
      return;
    }
    const direction = button.dataset.b4CarouselDirection === 'next' ? 1 : -1;
    track.scrollBy({ left: (rtl ? -1 : 1) * direction * track.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
  });

  mobile.addEventListener?.('change', () => observed.forEach(schedule));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-b4-card-carousel]').forEach(release));
  ['shopify:collection:update', 'shopify:search:update'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      Promise.resolve(event.promise).then(() => requestAnimationFrame(() => init())).catch(() => {});
    });
  });
})();
